<template>
  <public-layout>
    <section class="hero lvl2">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Trainer Training Program
              </p>
              <p class="product-subtitle">
                Making you a leader in the global educator community!
              </p>
              <p class="product-description">
                Enables experienced early-years professionals to train colleagues and local teachers in
                 Fun Learning. The program starts with 3 days of on-site training in Finland.
                  It continues for a minimum of 6 months upto one year with online trainer community support.
                   Equips trainer trainees to localize ‘Basic Fun Learning Educator Training’ to fit a
                    designated language and cultural setting.
              </p>
              <p class="product-cta">
                <router-link class="button button-large button-secondary" :to="{ name: 'prof-dev' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/trainer-training-big.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr>

    <section class="section course-info is-centered">
      <div class="container">
        <div class="content">
          <h2>Your journey to becoming a Fun Academy Trainer</h2>
          <p>Modules to be completed within the 12-month training period -</p>

          <img class="info-observation" src="/static/img/assets/trainer-training-observation.jpg" alt="Observation modules">
          <img class="info-online" src="/static/img/assets/trainer-training-online.jpg" alt="Online modules">
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.product-cta{
  margin-top: 1.5rem;
}

.product-image{
  width: 480px;
  height: 320px;
}

.info-observation,
.info-online {
  display: block;
  margin-top: 3rem;
  margin-left: auto;
  margin-right: auto;
}

.info-observation {
  max-width: 320px;
}

.info-online {
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/TrainerPage.vue